import { Card, Carousel } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuthHelper } from '../../../auth/auth-helper';
import {
  RBHBox,
  RBHText,
  RBHImage,
} from '../../../shared/components';
import styleText from '../../../shared/components/rbh-text/styles';
import { Images } from '../../../shared/theme';
import { mainCreators } from '../../main-action';
import { BUSINESS_TYPE } from '../../main-constant';
import { MAIN_STATE_KEY } from '../../main-reducer';
import styles from './styles';
import './styles.css';

import BranchSvg from '../../../shared/resources/image/svg/main/branch.svg';
import BranchManagerSvg from '../../../shared/resources/image/svg/main/branch-manager.svg';
import VatAddressSvg from '../../../shared/resources/image/svg/main/vat-address.svg';
import MenuSvg from '../../../shared/resources/image/svg/main/menu.svg';
import MenuCategorySvg from '../../../shared/resources/image/svg/main/menu-category.svg';
import ReportSvg from '../../../shared/resources/image/svg/main/report.svg';

export const MainScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isMart = AuthHelper.getBusinessTypeId() === BUSINESS_TYPE.MART;

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 0));
  }, []);

  const callConfirmAllChange = () => {
    dispatch(mainCreators.postConfirmAllChange());
  };

  return (
    <RBHBox style={styles.defaultContent}>
      {/* Banner */}
      <RBHBox style={{ width: '100%', padding: 'clamp(12px, 2vw, 24px)' }}>
        <div className='banner-wrapper'>
          <Carousel autoplay>
            <div className='img-banner'></div>
          </Carousel>
        </div>
      </RBHBox>
      {/* Content */}
      <RBHBox id={'id-main-box-title'} style={styles.titleBox}>
        <RBHText
          id={'id-main-text-title'}
          style={styleText.textTitle}
          data-testid={'id-main-text-title'}
          text={'main.title'}
        />
        <RBHText
          id={'id-main-text-description'}
          style={styleText.text16DarkGray}
          data-testid={'id-main-text-description'}
          text={`main.description.${isMart ? 'mart' : 'food'}`}
        />
      </RBHBox>
      {isMart ? (
        <RBHImage
          data-testid={'mart-main-image'}
          id={'mart-main-image'}
          style={styles.martImage}
          src={Images.mainMart}
        />
      ) : (
        <RBHBox style={styles.container}>
          <RBHBox className="main-grid-container">
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'branchmanagement-1'}
                onClick={() => history.push('/main/branchmanagement')}
                hoverable
                extra={
                  <img
                    id={'img-branchmanagement'}
                    src={BranchSvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-branchmanagement'}
                    style={styles.titleContent}
                    text={'main.card1'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'usermanagement-2'}
                onClick={() => history.push('/main/usermanagement') }
                hoverable
                extra={
                  <img
                    id={'img-branchmanagement'}
                    src={BranchManagerSvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-branchmanagement'}
                    style={styles.titleContent}
                    text={'main.card2'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'vataddress-3'}
                onClick={() => history.push('/main/vataddress')}
                hoverable
                extra={
                  <img
                    id={'img-vataddress'}
                    src={VatAddressSvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-vataddress'}
                    style={styles.titleContent}
                    text={'main.card3'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'foodcategory-5'}
                onClick={() => history.push('/main/foodcategory')}
                hoverable
                extra={
                  <img
                    id={'img-foodcategory'}
                    src={MenuCategorySvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-foodcategory'}
                    style={styles.titleContent}
                    text={'main.card5'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'foodmenu-6'}
                onClick={() => history.push('/main/foodcategory')}
                hoverable
                extra={
                  <img
                    id={'img-foodmenu'}
                    src={MenuSvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-foodmenu'}
                    style={styles.titleContent}
                    text={'main.card6'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'report-7'}
                onClick={() => history.push('/main/report')}
                hoverable
                extra={
                  <img
                    id={'img-report'}
                    src={ReportSvg}
                  />
                }
                title={
                  <RBHText
                    id={'text-report'}
                    style={styles.titleContent}
                    text={'main.card7'}
                  />
                }
                headStyle={{
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                bordered={false}
                bodyStyle={{ padding: 0, margin: 0, }}
                style={styles.card}
              />
            </RBHBox>
          </RBHBox>
        </RBHBox>
      )}
    </RBHBox>
  );
};

type Props = {};
